import { useCallback, useEffect, useState } from 'react';

function setToLocalStorage(value, key) {
  if (localStorage && key) {
    const dataJSON = JSON.stringify(value);
    localStorage.setItem(key, dataJSON);
  }
}

function getFromLocalStorage(key) {
  if (localStorage && key) {
    const JSONData = localStorage.getItem(key);
    return JSONData && JSON.parse(JSONData);
  }
}

function useLocalStorage(key: string, defaultValue: any) {
  const [value, setValue] = useState(() => getFromLocalStorage(key) || defaultValue);

  useEffect(() => {
    if (key) {
      const storageValue = getFromLocalStorage(key);

      if (!storageValue || storageValue !== value) {
        setToLocalStorage(value, key);
      }
    }
  }, [value, key]);

  const updateLocStorageValue = useCallback((val) => setValue(val), []);

  return {
    value,
    updateLocStorageValue,
  };
}

export default useLocalStorage;
